import React from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { isPatientOrMember } from "../../security/roles";
import history from "../../history";

function GoToHome({ userRole }) {
  return (
    <div>
      <Button
        className="btn btn-secondary"
        onClick={() => {
          window.close();
          setTimeout(() => {
            history.push(isPatientOrMember(userRole) ? "/app" : "/");
          }, 150);
        }}
      >
        Close
      </Button>
    </div>
  );
}

const mapstatetoprops = (state, ownProps) => {
  return {
    userRole: state.user.role
  };
};

export default connect(mapstatetoprops)(GoToHome);
